<template>
  <div class="meeting-answers-modal">
    <HMModalHeader
      :title="$t('MARKETING.TITLES.MEETING_ANSWERS')"
      @close="$emit('close')"
    />
    <div v-for="question in questions" :key="question.position" class="my-4">
      <div class="question">{{ question.label }}</div>
      <div class="answer">{{ question.answer }}</div>
    </div>
  </div>
</template>

<script>
import { HMModalHeader } from '@/web/components/common';

export default {
  name: 'MeetingAnswersModal',
  components: {
    HMModalHeader,
  },
  props: {
    meeting: {
      type: Object,
    },
  },
  computed: {
    questions() {
      if (!this.meeting?.form) return [];
      return (
        [...this.meeting.form].sort((p1, p2) => p1.position - p2.position) ?? []
      );
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.question {
  font-weight: bold;
  font-size: 1.2rem;
  color: $gray-700;
}
.answer {
  font-size: 1.2rem;
  color: $gray-500;
}
</style>
